import { AppRoutes } from "config/router";
import * as lodash from 'lodash';
import { Link } from "react-router-dom";
import useAppTranslation from "../../utilities/hooks/useAppTranslation";

type AppLinkPropsType = {
    to: AppRoutes | string,
    params?: Record<string, string | number | undefined>
    children: React.ReactNode | React.ReactNode[],
    className?: string,
    active?: any,
    title?: string
    name?: string
}

const resolveRoute = (route: AppRoutes | string, params: Record<string, string | number | undefined> | undefined) : string => {
    if(!params || lodash.isEmpty(params)) return route;
    let routeVal = route + '';

    if(params) {
        for(let key in params) {
            if(params[key]) routeVal = routeVal.replace(':' + key, params![key]!.toString());
        }
    }

    return routeVal;
}

const AppLink = (props: AppLinkPropsType) => {
    const translation = useAppTranslation();
    const link = resolveRoute(props.to, props.params);
    let className = props.className;
    if(props.active) className += " active".trim();
    const title = translation(props.title);
    return <Link to={link} title={title!} className={className}>
        {props.children}
    </Link>
}

export default AppLink;
